// extracted by mini-css-extract-plugin
export default {"registrationTitle":"registrationTitle_registrationTitle__AqHy5","message":"registrationTitle_message__bVKFd"};